export default __webpack_public_path__ + "static/media/feature-monitoring-2.7182d47c.png";